import { useTranslation } from "react-i18next";
import ApplicationRequestCardComponent from "src/components/admin/application-request-card-component";
import { schoolApplicationRequestData } from "src/core/statics/schools-application-request-data/school-application-request-data";

function ApplicationRequestsForSchoolsContainer() {
  const { t } = useTranslation();
  const ApplicationRequestsData = schoolApplicationRequestData;

  return (
    <>
      {ApplicationRequestsData.length !== 1 || 0 ? (
        <ApplicationRequestCardComponent />
      ) : (
        <div className="flex flex-col justify-center items-center gap-5 pt-28 pb-48">
          <img alt="" src="/assets/icons/news-icon.svg" />
          <p className="text-zinc900 font-arRegular text-2xl">
            {t("applicationRequestsForSchools.container.noRequestsYet")}
          </p>
        </div>
      )}
    </>
  );
}

export default ApplicationRequestsForSchoolsContainer;
